import React, { useMemo } from 'react'
import { BaseEditorButton } from 'src/editor/shared/entities/base-editor-button'
import {
  FormInterface,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { FormBaseSubentity } from './form-base-subentity'

interface FormSubmitButtonSubentityProps {
  formEntity: FormInterface
  submitButtonSubentity: FormSubmitButtonInterface
}

export const FormSubmitButtonSubentity = ({
  formEntity,
  submitButtonSubentity,
}: FormSubmitButtonSubentityProps) => {
  const entity = useMemo(
    () => ({
      ...submitButtonSubentity,
      ...formEntity.buttonCommonStyles,
    }),
    [submitButtonSubentity, formEntity.buttonCommonStyles],
  )

  return (
    <FormBaseSubentity
      title={'entity_settings.submit_button.header'}
      formEntity={formEntity}
      subentity={submitButtonSubentity}
    >
      <BaseEditorButton entity={entity} />
    </FormBaseSubentity>
  )
}
